module.exports = __webpack_public_path__ + "img/5.e26f2fc3.jpg";